/**
 * 直播账号来源接口
 * 直播Agent 新版页面仅保留账号列表查询，配置/记录/报表接口见 src/api/liveAgent.ts
 */
import { apiGet } from '@/utils/request';
import type { LiveAccountItem } from '@/types/live';

/**
 * 按平台（dy / xhs / kuaishou）拉取直播账号列表
 * GET /channels/accounts-by-source?source=dy
 * 响应结构：{ code: 0, msg: 'ok', data: { list: LiveAccountItem[] } }
 * 拦截器已自动解包一层，调用方拿到的是 { list: LiveAccountItem[] }
 */
export interface LiveAccountListResponse {
  list: LiveAccountItem[];
}

export const liveAccountApi = {
  bySource: (source: string) =>
    apiGet<LiveAccountListResponse>('/channels/accounts-by-source', { source }),
};
